/* eslint-disable */
import ls from 'local-storage';
import SearchFormAutocompleteView from './SearchFormAutocomplete';
import SearchRouter from "@/js/common/Domain/Router/SearchRouter";
import toLocalStorageTourCriteriaHydrator from "@/js/common/Domain/Hydrator/toLocalStorageTourCriteria";
import searchHistoryService from "@/js/common/Domain/Service/searchHistory";
import toRouterHotelHydrator from "@/js/common/Domain/Hydrator/toRouterHotel";
import toRouterHydrator from "@/js/common/Domain/Hydrator/toRouter";
/*import bookingPopupService from '@/js/common/Domain/Service/bookingPopup';*/
import tourCriteriaService from "@/js/common/Domain/Service/tourCriteria";
import DataLayerAnalytics from "@/js/common/Domain/Service/DataLayerAnalytics";

let SearchFromAutocomplete = Backbone.View.extend({
	initModels: function () {
		console.time('init');
		var self = this;

		this.searchFormView = new SearchFormAutocompleteView();
		this.model = this.searchFormView.model;
		this.dataLayerAnalytics = new DataLayerAnalytics();
	},
	initEvents: function () {
		this.model.get('departureCity').on('change:model', $.proxy(this.model.departureCityChanged, this));
		this.model.get('countries').on('change:model', $.proxy(this.model.countriesChanged, this));
		this.model.get('resorts').on('change:model', $.proxy(this.model.resortsChangedForCriteria, this));
	},
	initDomEvents: function () {
		var self = this;
		$('#startSearch').on('click', function () {
			self.formSubmit();
		});
	},
	formSubmit: function () {
		var self = this,
			currentTourCriteria = self.model.getTourCriteria(),
			paramsForRouter,
			paramsForLocalStorage = toLocalStorageTourCriteriaHydrator(currentTourCriteria),
			goToUrl,
			router = new SearchRouter().getInstance();

		if (currentTourCriteria.isValid() && self.searchFormView.isValid()) {
			$.cookie('requestFromMainPage', true, {path: '/', domain: 'all'});
			$.cookie('markSearchSource', true, {path: '/', domain: 'all'});

			ls.set('tourCriteria', paramsForLocalStorage);

			searchHistoryService.addSearch(currentTourCriteria);

			if (currentTourCriteria.get('hotels') && currentTourCriteria.get('hotels').length == 1) {
				paramsForRouter = toRouterHotelHydrator({tourCriteria: currentTourCriteria});
				goToUrl = '/goto/hotel/' + currentTourCriteria.get('hotels').at(0).get('id') + '#?' + $.param(paramsForRouter);
			} else {
				paramsForRouter = toRouterHydrator(currentTourCriteria);
				goToUrl = '/search#?' + $.param(paramsForRouter);
			}

			this.dataLayerAnalytics.clickSearchButtonEvent();

			router.go(goToUrl);
		}
	},
	loadFormData: function () {
		var setTourCriteria,
			tourCriteriaFromLocalStorage,
			self = this,
			loadTourCriteriaWithFormData = function (params) {
				tourCriteriaService.loadTourCriteriaWithFormData(params, {
					success: function (tourCriteria) {
						self.model.setTourCriteria(tourCriteria);
					},
					error: function (tourCriteria) {
					}
				});
			};

		this.model.get('countries').setNull();
		this.model.get('resorts').setNull();
		this.model.get('hotels').setNull();
		this.model.get('checkInDateRange').setNull();
		this.model.get('nightRange').setNull();
		this.model.get('touristGroup').setNull();
		this.model.get('hotelCategories').setNull();
		this.model.get('meals').setNull();
		this.model.get('priceRange').setNull();

		if (typeof window.appConfig.defaultCountryId == 'undefined' && typeof window.appConfig.defaultResorts == 'undefined') {
			tourCriteriaFromLocalStorage = ls.get('tourCriteria');
		}

		setTourCriteria = tourCriteriaFromLocalStorage ? tourCriteriaFromLocalStorage : {};

		if (typeof (window.appConfig.defaultTourCriteria) !== 'undefined') {
			$.extend(setTourCriteria, window.appConfig.defaultTourCriteria);
		}

		loadTourCriteriaWithFormData({
			setTourCriteria: setTourCriteria
		});
	},
	trackSearchFormView: function () {
		//fixed
		this.dataLayerAnalytics.generateEvent("cacheResults", false);
		this.dataLayerAnalytics.preSearchPagePath();
	},
	initialize: function () {
		tourCriteriaService.clearTourCriteriaChangedFields();
		this.initModels();
		this.initEvents();
		this.initDomEvents();
		this.loadFormData();
		this.trackSearchFormView();
	}
});

export default SearchFromAutocomplete;